import React from "react";
import { getClassName } from "@sscs/utils";
import { isEqual } from "lodash";
import ResetFilters from "../ResetFilters";
import styles from "./foundSummary.module.scss";
/** Count the filter fields whose current value differs (deep-compared) from their initial. A field present in only one object counts as changed. */
const countActiveFilters = (initial, active) => {
    const initialRecord = initial;
    const activeRecord = active;
    const keys = new Set([...Object.keys(initial), ...Object.keys(active)]);
    let changed = 0;
    keys.forEach((key) => {
        if (!isEqual(initialRecord[key], activeRecord[key]))
            changed += 1;
    });
    return changed;
};
/** Whether any filter field differs from its initial value — the comparison behind the "N filters active" caption. */
export const hasActiveFilters = (initial, active) => countActiveFilters(initial, active) > 0;
/**
 * The "N results · M filters active · Reset filters" caption under a band's filter controls.
 * Reached only through `Page.Filters`' or `FiltersContainer`'s `found` prop.
 */
const FoundSummary = ({ id, count, label, initialFilters, activeFilters, onClear, className, }) => {
    const classes = getClassName(styles.summary, className);
    if (count === undefined && label === undefined) {
        return (React.createElement("div", { className: classes },
            React.createElement("span", null, "\u200b")));
    }
    const activeCount = countActiveFilters(initialFilters, activeFilters);
    return (React.createElement("div", { className: classes },
        React.createElement("span", null, label !== null && label !== void 0 ? label : `${(count !== null && count !== void 0 ? count : 0).toLocaleString()} ${count === 1 ? "result" : "results"}`),
        activeCount > 0 && (React.createElement(React.Fragment, null,
            React.createElement("span", { className: styles.separator, "aria-hidden": "true" }, "\u00B7"),
            React.createElement("span", null,
                activeCount,
                " ",
                activeCount === 1 ? "filter" : "filters",
                " active"),
            React.createElement("span", { className: styles.separator, "aria-hidden": "true" }, "\u00B7"),
            React.createElement(ResetFilters, { id: id, onClick: onClear })))));
};
export default FoundSummary;
//# sourceMappingURL=FoundSummary.js.map